import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Button from '@mui/material/Button';

import { Outlet, Link } from "react-router-dom";

const AppBoardScreen = () => {
    return (
        <Box id="AppBoardScreen2" className="AppBoardScreen AppBoardScreen2" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/InOrderContinueProcessFinishProcesSpending">
                        <Button variant="outlined" size="large">Regresar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">Para poder continuar el proceso debemos realizar una revisión del historial pero tendrá un costo adicional de $20, de esta manera podremos ver qué es lo que esta impidiendo continuar con este proceso</h2>
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/cambio/InOrderContinueProcessFinishProcesSpending">
                        <Button variant="contained" color="success" size="large" sx={{ width: "50%" }}>Solicitar récord</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h6 className="subHeading">Cancelar</h6>
                </Grid>
              
                <Outlet/>
            </Grid>
        </Box>
    );
};

export default AppBoardScreen;